import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { Grid, InputLabel } from "@material-ui/core";

import { MiscellaneousIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { LabledTextField } from "../core/LabledTextField";

export const AdjustableLoadElectricMiscellaneousForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } = useFormModel<
        ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_MISCELLANEOUS
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<MiscellaneousIcon />}
                content={
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Sonstige Verbraucher
                        </p>
                }
                useSwitch={
                    <Switch
                        checked={values.adjustableLoadElectricMiscellaneous.value.installed}
                        {...getFieldProps("adjustableLoadElectricMiscellaneous.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.adjustableLoadElectricMiscellaneous.value.installed = checked;
                                values.adjustableLoadElectricMiscellaneous.value.description = checked ? "" : null;
                                values.adjustableLoadElectricMiscellaneous.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.adjustableLoadElectricMiscellaneous.value.installed}
                detail={
                    <Grid
                        container
                        spacing={4}
                        alignItems="flex-end"
                        style={{ paddingBottom: "12px" }}
                    >
                        <Grid item xs={12} md={8}>
                            <LabledTextField
                                label="Bezeichnung"
                                variant="outlined"
                                style={{ width: "100%" }}
                                placeholder="Motoren, Schweißgeräte, etc."
                                InputProps={{
                                    className: classes.textField,
                                    style: { width: "100%" },
                                    inputProps: {
                                        style: { fontFamily: "innogyWeb" },
                                    },
                                }}
                                inputProps={{
                                    maxLength: 100,
                                }}
                                value={
                                    values.adjustableLoadElectricMiscellaneous.value.description
                                }
                                onChange={(v) =>
                                    setValues((values) => {
                                        values.adjustableLoadElectricMiscellaneous.value.description =
                                            v.target.value;
                                    })
                                }
                                error={!!values.adjustableLoadElectricMiscellaneous.error}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputLabel className={classes.labledTextfieldLabel}>
                                Summe der Leistung
                            </InputLabel>
                            <NumberInput
                                className={classes.textField}
                                style={{ width: "100%" }}
                                fixedDecimalScale={false}
                                allowLeadingZeros={false}
                                decimalScale={
                                    values.adjustableLoadElectricMiscellaneous.value.demand
                                        .precision
                                }
                                isNumericString={false}
                                allowNegative={false}
                                thousandSeparator="."
                                decimalSeparator=","
                                adornment={
                                    values.adjustableLoadElectricMiscellaneous.value.demand.unit
                                }
                                value={
                                    values.adjustableLoadElectricMiscellaneous.value.demand
                                        .amount || ""
                                }
                                placeholder="0"
                                onValueChange={(v) =>
                                    setValues((values) => {
                                        values.adjustableLoadElectricMiscellaneous.value.demand.amount =
                                            v.floatValue || null;
                                    })
                                }
                                error={!!values.adjustableLoadElectricMiscellaneous.error}
                            />
                        </Grid>
                    </Grid>
                }
            />
        </Fragment>
    );
};
